import { getCountry } from '../iwIntlProvider/CountryProvider';

export function getCurrenySymbolFromCode(code) {
    if (code === 'GBP') return '£';
    if (code === 'EUR') return '€';
    return '£';
}

export function getDecimalSymbol() {
    const country = getCountry();

    switch (country) {
        case 'DE':
            return ',';
        default:
            return '.';
    }
}
